import { create } from "zustand";
import type { Language } from "./i18n";

interface LangStore {
  lang: Language;
  setLang: (lang: Language) => void;
  toggleLang: () => void;
}

export const useLangStore = create<LangStore>((set, get) => ({
  lang: "en",
  setLang: (lang) => {
    set({ lang });
    // Update HTML dir and lang attributes
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    document.documentElement.style.fontFamily =
      lang === "ar"
        ? '"Cairo", "Inter", system-ui, sans-serif'
        : '"Inter", "Cairo", system-ui, sans-serif';
  },
  toggleLang: () => {
    const next = get().lang === "en" ? "ar" : "en";
    get().setLang(next);
  },
}));

export function useT() {
  const lang = useLangStore((s) => s.lang);
  // dynamic import — we inline translations here
  return lang;
}
